import './index.css';

export default {
  name: 'Arow',
  props: {
    gutter: { type: Number | String, default: () => 16 },
    flex: { type: Boolean, default: () => true },
  },
  data() {
    const { width = null, height = null, margin = null } = this.$attrs;
    return ({
      width,
      height,
      margin,
    });
  },
  created() {
    this.create();
  },
  methods: {
    create() {
      if (this.gutter) {
        const number = Math.floor(parseInt(this.gutter) / 2);
        const margin = (number % 2 === 0 ? number : (number + 1));
        this.margin = (`-${margin}px`);
      }
      this.flex && this.$nextTick(() => {
        !this.width && (this.width = (`${this.$el.clientWidth}px`));
        !this.height && (this.height = (`${this.$el.clientHeight}px`));
      });
    },
  },
  render() {
    const { padding = null, ...attrs } = this.$attrs;
    return (
      <el-row
        style={{ padding, margin: this.margin, width: this.width, height: this.height }}
        class={['a-row', (this.flex ? 'flex' : null)]}
        gutter={parseInt(this.gutter)}
        {...{ attrs }}
      >
        {this.$slots.default}
      </el-row>
    );
  }
}